import type { InboxItem } from "./eventQueueInbox";
import { useEventQueueInbox } from "./useEventQueueInbox";

export type RailIndicator = "critical" | "warning";

/** Away from Queues the Inbox is only read for the rail's dot, so once a minute is plenty. */
const RAIL_REFRESH_MS = 60_000;

/**
 * Whether anything in the Inbox needs a person: critical when something is
 * stopped or failing hard, warning otherwise, nothing when it's empty or
 * everything is acknowledged. It reads the same Inbox as the Queues page, so
 * the dot and the Inbox never disagree.
 */
export function railIndicator(items: readonly InboxItem[]): RailIndicator | null {
  if (items.some((item) => item.severity === "critical")) return "critical";
  return items.length > 0 ? "warning" : null;
}

/** The Queues rail dot; reads nothing for someone without the tool. */
export function useQueuesRailIndicator(enabled: boolean): RailIndicator | null {
  const { items } = useEventQueueInbox({ enabled, refetchInterval: RAIL_REFRESH_MS });
  return enabled ? railIndicator(items) : null;
}
